import { Inject } from 'inversify-props'
import { FaqServiceAdapter } from "./adapter";


export class DeleteFaqUseCase {
	@Inject('FaqServiceAdapter')
	private service!: FaqServiceAdapter

	delete = async (id: string): Promise<void> => await this.service.remove(id)
}